import { render } from "./Awards.vue?vue&type=template&id=750c6744&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"

import "./Awards.vue?vue&type=style&index=0&id=750c6744&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-750c6744"

export default script